/* eslint-disable indent */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        title: '首页',
        path: '/',
        redirect: '/start',

    },
    {
        path: '*',
        name: '404',
        component: () => import('@/views/404.vue'),
        meta: { title: '404' }
    },
    // 项目开始 首页
    {
        path: '/start',
        name: 'start',
        component: () => import('@/views/start.vue'),
        meta: { title: '首页' }
    },
    // 项目开始 首页
    {
        path: '/start-mobile',
        name: 'start-mobile',
        component: () => import('@/views/start-mobile.vue'),
        meta: { title: '首页移动端' }
    },
    // 关于我们
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about.vue'),
        meta: { title: '关于我们' }
    },
    // 科技研发
    {
        path: '/technology',
        name: 'technology',
        component: () => import('@/views/technology.vue'),
        meta: { title: '科技研发' }
    },
    {
        path: '/health',
        name: 'health',
        component: () => import('@/views/health.vue'),
        meta: { title: '健康' }
    },
    // 机构赋能
    {
        path: '/institution',
        name: 'institution',
        component: () => import('@/views/institution.vue'),
        meta: { title: '机构赋能' }
    },
    // 明星产品
    {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product.vue'),
        meta: { title: '产品系列' }
    },
    // 新闻资讯
    {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news.vue'),
        meta: { title: '新闻资讯' }
    },

    // 新闻资讯详情
    {
        path: '/news-info',
        name: 'news-info',
        component: () => import('@/views/news-info.vue'),
        meta: { title: '新闻资讯' }
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
